import { all } from 'redux-saga/effects';
import details from 'sagas/profile/details';
import password from 'sagas/profile/password';

export default function* profile() {
  yield all([details(), password()]);
}
